import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BotMessagesComponent } from './bot-messages/bot-messages.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    BotMessagesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule
  ]
})
export class BotMessagesModule { }
